import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import * as pbi from 'powerbi-client';
import { RequestTripDetail } from 'src/app/interfaces/RequestTripDetail';
import { ArribalAtPlant, AttributeValues, Client, IDetailTripResponse } from 'src/app/interfaces/Responses/IDetailTripResponse';
import { RealTimeService } from 'src/app/services/dashboards/real-time.service';
import { SharedService } from '../../../services/dashboards/shared.service';
import { Image } from '../../../interfaces/Responses/IDetailTripResponse'
import { FilterGD, SourcePowerBIEnum } from 'src/app/interfaces/models/filter-item.model';
import { Data } from 'src/app/interfaces/Responses/IPBITokenInfoResponse';
import { FiltersGeneralDashboardModel } from 'src/app/interfaces/models/filters-general-dashboard.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'neoris-truck-efficiency-dashboard',
  templateUrl: './truck-efficiency-dashboard.component.html',
  styleUrls: ['./truck-efficiency-dashboard.component.css']
})
export class TruckEfficiencyDashboardComponent implements OnInit {

  id: string
  response: IDetailTripResponse
  public screenHeight: number;

  modalActivo: boolean = false
  @ViewChild('popup') popup: ElementRef;
  @ViewChild('blur') blur: ElementRef;

  desktopView: MediaQueryList = matchMedia('(min-width: 1280px)')
  _site: string;
  currentFormat: string = '1'
  descargado: boolean = false
  type: string
  dashboardTypeId: string = '1102'
  businessUnitId: string = '1'

  detailTruckForm: UntypedFormGroup
  currentLicensePlate: string
  currentTruckNumber: string
  currentCompany: string
  currentDotNumber: string
  currentType: string
  _tripID: string
  _edit: boolean = true
  responseDetail: IDetailTripResponse
  imagesOfTrucks: Image[]
  arribalAtPlant: ArribalAtPlant[]
  companies: Client[] = []
  types: AttributeValues[] = []
  parentMessage: IDetailTripResponse
  lastUpdate: string
  report: any
  filtersGeneralDashboardModel: FiltersGeneralDashboardModel

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(evt: KeyboardEvent) {
    if (evt.key === 'Escape') {
      this.configurarModal()
    }
  }

  slidePosition = 0;
  slides: any
  totalSlides: number = 0

  ImagesCheckPoint: string[] = []

  constructor(private renderer: Renderer2,
    private realTimeService: RealTimeService,
    private sharedService: SharedService,
    private builder: UntypedFormBuilder) { }

  async ngOnInit(): Promise<void> {
    this.type = '2'
    this._site = localStorage.getItem('site')
    this.screenHeight = (window.screen.height)
    this.desktopView.addEventListener('change', this.changeSize)
    this.configDetailTrip()
    let data = await this.getConfigurationReport(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
    localStorage.setItem('config-current-report', JSON.stringify(data.data))
    let configReport = localStorage.getItem('config-current-report')
    this.showReport(JSON.parse(configReport))
    this.slides = document.getElementsByClassName('carousel__item')
    setInterval(async () => {
      let data = await this.getConfigurationReport(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
      localStorage.setItem('config-current-report', JSON.stringify(data.data))
      let configReport = localStorage.getItem('config-current-report')
      this.showReport(JSON.parse(configReport))
      document.getElementById('message-update').style.display = 'block'
      let today = new Date()
      this.lastUpdate = today.toLocaleString()
    }, 5 * 60 * 60 * 1000)
  }

  async getConfigurationReport(_site: string, type: string, dashboardTypeId: string, businessUnitId: string): Promise<any> {
    return this.sharedService.getPBITokenInfo(this._site, type, dashboardTypeId, businessUnitId).toPromise()
  }

  onKeyLP(value: any) {
 
  }

  onKeyTN(value: string) {
  }

  onKeyDN(value: string) {
  }

  changeType(type: string) {
  }

  changeCompany(company: string) {
    this.responseDetail.dotNumber = company
    this.currentDotNumber = company
    document.getElementById('dotNumber').setAttribute('placeholder', company)
    document.getElementById('dotNumber').setAttribute('value', company)
  }

  closeModal() {
    document.getElementById('myModal').style.display = 'none'
  }

  UpdateDetailTruck(values: any) {
    let requesTripDetail = new RequestTripDetail()
    requesTripDetail.tripId = Number(this._tripID)
    requesTripDetail.license = this.currentLicensePlate
    requesTripDetail.dotNumber = this.currentDotNumber
    requesTripDetail.truckNumber = this.currentTruckNumber
    requesTripDetail.truckType = Number(this.currentType)
    this.realTimeService.UpdateTripDetail(requesTripDetail).subscribe((e) => {
      document.getElementById('resolution').style.display = 'block'
      setTimeout(() => {
        document.getElementById('resolution').style.display = 'none'
      }, 3000)
    })
    this.toogleEdit()
  }

  toogleEdit() {
    this._edit = !this._edit
  }

  configDetailTrip() {
    this.detailTruckForm = this.builder.group({
      plateNumber: [''],
      truckNumber: [''],
      govNumber: [''],
      dotNumber: [''],
      attributeValue: ['']
    })
  }

  closeModalDetail() {
    document.getElementById('modalDetailGD').style.display = 'none'
  }

  changeFormat(format: string) {
    this.currentFormat = format
  }

  async ReloadDashboard() {
    const pages = await this.report.getPages()
    const page = pages.find(p => p.isActive)
    const visuals = await page.getVisuals()
    const filters = await visuals.filter(t => t.title !== undefined && t.type === 'slicer')
    await this.setFilters(filters)
    this.descargado = true
    this.sharedService.getExportStream(this._site, '5', this.currentFormat, this.dashboardTypeId, this.businessUnitId, this.filtersGeneralDashboardModel, SourcePowerBIEnum.LPE).subscribe((response) => {
      this.showFile(response)
      this.descargado = false
    })
  }

  async setFilters(filters: any): Promise<void> {
    const carrier = await filters.filter(f => f.title === FilterGD.Carrier)
    const year = await filters.filter(f => f.title === FilterGD.Year)
    const month = await filters.filter(f => f.title === FilterGD.Month)
    const day = await filters.filter(f => f.title === FilterGD.Day)
    const plateSearch = await filters.filter(f => f.title === FilterGD.PlateSearchLower)

    const filterCarrier = await carrier[0].getSlicerState()
    const filteryear = await year[0].getSlicerState()
    const filtermonth = await month[0].getSlicerState()
    const filterday = await day[0].getSlicerState()
    const filterplateSearch = await plateSearch[0].getSlicerState()

    this.filtersGeneralDashboardModel = {
      filters: [
        {
          target: filterCarrier.filters[0]?.target,
          operator: filterCarrier.filters[0]?.operator,
          values: filterCarrier.filters[0]?.values
        },
        {
          target: filterplateSearch.filters[0]?.target,
          operator: filterplateSearch.filters[0]?.operator,
          values: filterplateSearch.filters[0]?.values
        },
        {
          target: filteryear.filters[0]?.target,
          operator: filteryear.filters[0]?.operator,
          values: filteryear.filters[0]?.values
        },
        {
          target: filtermonth.filters[0]?.target,
          operator: filtermonth.filters[0]?.operator,
          values: filtermonth.filters[0]?.values
        },
        {
          target: filterday.filters[0]?.target,
          operator: filterday.filters[0]?.operator,
          values: filterday.filters[0]?.values
        }
      ]
    }
    this.filtersGeneralDashboardModel.filters = this.filtersGeneralDashboardModel.filters.filter(f => f.values != null && f.target != null)
  }

  showFile(blob: Blob) {
    let newBlob = blob

    const data = window.URL.createObjectURL(newBlob)
    let link = document.createElement('a')
    link.href = data
    switch (this.currentFormat) {
      case '1':
        link.download = "LoadingPointEfficiency.pdf"
        break
      case '2':
        link.download = "LoadingPointEfficiency.pptx"
        break
    }
    link.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  changeSize(mql) {
    mql.matches ?
      this.sharedService.getPBITokenInfo(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
        .subscribe((response) => {
          let data = response.data
          this.showReport(data);
        }) :
      this.sharedService.getPBITokenInfo(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
        .subscribe((response) => {
          let data = response.data
          this.showReport(data);
        })
  }

  showReport2(data) {
    let embedUrl = data.embedReport[0].embedUrl
    let embedReportId = data.embedReport[0].reportId
    let config = {
      type: 'report',
      tokenType: 1,
      accessToken: data.embedToken.token,
      embedUrl: embedUrl,
      id: embedReportId,
      settings: {
        layoutType: 2,
        panes: {
          filters: {
            visible: false
          },
          pageNavigation: {
            visible: false
          }
        }
      }
    };
    let reportContainer = document.getElementById('truckefficiency')
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    let report = powerbi.embed(reportContainer, config);
    report.off("loaded");
    report.on("loaded", () => {
    });
    report.on("error", (e) => {
    });
    report.on('buttonClicked', (e) => {
      this.configurarModal()
      let { detail } = e
      this.id = detail['title']
      this.realTimeService.getDetailTrip(this.id, '2', false).subscribe(
        res => {
          this.response = res
        }
      )
    })
  }

  setCurrentValues(res: IDetailTripResponse) {
    this.currentLicensePlate = res.platE_NUMBER
    this.currentTruckNumber = res.truckNumber
    this.currentCompany = res.dotNumber
    this.currentDotNumber = res.dotNumber
    this.currentType = res.type

 
  }

  getCompanies(companies: Client[]): Client[] {
    let companiesList: Client[] = []
    let companiesObj: Client
    companies.forEach(element => {
      companiesObj = new Client()
      companiesObj.name = element.name
      companiesObj.govNumber = element.govNumber || 0
      companiesObj.selected = false
      companiesList.push(companiesObj)
    })
    return companiesList
  }

  getTypes(attributeValues: AttributeValues[]): AttributeValues[] {
    let typeList: AttributeValues[] = []
    let typeObj: AttributeValues
    attributeValues.forEach(element => {
      typeObj = new AttributeValues()
      typeObj.id = element.id
      typeObj.nameEn = element.nameEn
      typeObj.nameEs = element.nameEs
      typeObj.selected = false
      typeList.push(typeObj)
    })
    return typeList
  }

  getArribalAtPlant(responseDetail: IDetailTripResponse): ArribalAtPlant[] {
    let arribalAtPlant: ArribalAtPlant[] = []
    let arribalAtPlantObj: ArribalAtPlant
    responseDetail?.checkpoinT_STEPS?.forEach(element => {
      arribalAtPlantObj = new ArribalAtPlant()
      arribalAtPlantObj.steP_NAME = element.steP_NAME
      arribalAtPlantObj.averagE_TIME = element.averagE_TIME
      arribalAtPlantObj.averagE_MINUTES = element.averagE_MINUTES
      arribalAtPlantObj.averagE_MINUTES_HHMM = element.averagE_MINUTES_HHMM
      arribalAtPlantObj.image_trailer = responseDetail.images.filter(e => e.attributeType === 24 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL)
      arribalAtPlantObj.image_side = responseDetail.images.filter(e => e.attributeType === 25 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL)
      arribalAtPlantObj.image_truck = [...responseDetail.images.filter(e => e.attributeType === 2 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL), ...arribalAtPlantObj.image_trailer, ...arribalAtPlantObj.image_side]
      arribalAtPlantObj.image_license = responseDetail.images.filter(e => e.attributeType === 11 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL)
      arribalAtPlantObj.image_truck_number = responseDetail.images.filter(e => e.attributeType === 13 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL)
      arribalAtPlantObj.image_dot = responseDetail.images.filter(e => e.attributeType === 12 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL)
      arribalAtPlantObj.image_company = responseDetail.images.filter(e => e.attributeType === 14 && element.steP_ID === e.checkpoinT_ID).map(e => e.imagE_URL)
      arribalAtPlant.push(arribalAtPlantObj)
    })
    return arribalAtPlant
  }

  checkedCompany(govNumber: number) {
    let exist = this.companies.filter(c => c.govNumber === govNumber)
    if (exist.length > 0) this.companies.filter(c => c.govNumber === govNumber)[0].selected = true
  }

  checkedType(id: number) {
    let exist = this.types.filter(c => c.id === id)
    if (exist.length > 0) this.types.filter(c => c.id === id)[0].selected = true
  }

  zoom(urlImage: string[]) {
    this.totalSlides = urlImage.length
    this.ImagesCheckPoint = urlImage
    this.slides[0].classList.add('carousel__item--visible')
    document.getElementById('myModal').style.display = 'block'
  }

  goToModalDetail(e: any) {

    let { detail } = e
    this.id = detail['title']

    this.responseDetail = null
    this.arribalAtPlant = null
    document.getElementById('modalDetailGD').style.display = 'block'
    this._tripID = this.id
    this.realTimeService.getDetailTrip(this._tripID, this.type, false).subscribe(
      res => {
        if (res !== null) {
          this.parentMessage = res
          this.responseDetail = res
          this.setCurrentValues(res)
          if (res.companies != null && res.companies.length > 0) this.companies = this.getCompanies(res.companies)
          if (res.attributeValues != null && res.attributeValues.length > 0) this.types = this.getTypes(res.attributeValues)
          if (this.responseDetail.dotNumber !== null) this.checkedCompany(Number(this.responseDetail.dotNumber))
          if (this.responseDetail.type !== null) this.checkedType(Number(this.responseDetail.type))
          this.arribalAtPlant = this.getArribalAtPlant(this.responseDetail)
        }
      }
    )
  }

  previousSlide() {
    this.moveToPrevSlide()
  }

  moveToPrevSlide() {
    if (this.slidePosition === 0) {
      this.slidePosition = this.totalSlides - 1;
    } else {
      this.slidePosition--
    }
    this.updateSlidePosition()
  }

  nextSlide() {
    this.moveToNextSlide()
  }

  moveToNextSlide() {
    if (this.slidePosition === this.totalSlides - 1) {
      this.slidePosition = 0
    } else {
      this.slidePosition++
    }
    this.updateSlidePosition()
  }

  updateSlidePosition() {
    for (let i = 0; i < this.slides.length; i++) {
      const slide = this.slides[i];
      slide.classList.remove('carousel__item--visible')
      slide.classList.add('carousel__item--hidden')
    }
    this.slides[this.slidePosition].classList.add('carousel__item--visible')
  }

  async showReport(data: Data) {
    let models = pbi.models
    let permissions = models.Permissions.Read
    let loadedResolve, reportLoaded = new Promise((res, rej) => { loadedResolve = res })
    let renderedResolve, reportRendered = new Promise((res, rej) => { renderedResolve = res })
    let embedUrl = data.embedReport[0].embedUrl
    let embedReportId = data.embedReport[0].reportId
    let reportContainer = <HTMLElement>document.getElementById('truckefficiency')
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)
    powerbi.reset(reportContainer)
    let config = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: data.embedToken.token,
      embedUrl: embedUrl,
      id: embedReportId,
      permissions: permissions,
      viewMode: models.ViewMode.View,
      settings: {
        layoutType: models.LayoutType.Master,
        bars: {
          actionBar: { visible: false }
        },
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false },
          bookmarks: { visible: false }
        }
      }
    }


    try {
      this.report = <pbi.Report>powerbi.embed(reportContainer, config) as pbi.Visual
      this.report.off("loaded")
      this.report.on("loaded", () => {
        const filter = {
          $schema: environment.urlPowerBI,
          target: {
            table: "BIG_TABLE_EFFICIENCY",
            column: "ID_FACILITY"
          },
          operator: "In",
          values: [localStorage.getItem('site')],
          filterType: 1,
          requireSingleSelection: true
        }
        this.report.setFilters([filter]).then(res => {
          this.report.getFilters().then(filters => {
          });
        }).catch(error => {
        });
        loadedResolve()
        this.report.off("loaded")
      })
      this.report.off("error")
      this.report.on("error", (e) => {
        this.changeSize(this.desktopView)
      })
      this.report.off("rendered")
      this.report.on("rendered", function () {
        renderedResolve()
      })
      this.report.on('buttonClicked', (e) => {
        this.goToModalDetail(e)
      })
    } catch (error) {
    }
    await reportLoaded
    await reportRendered
  }

  configurarModal() {
    this.modalActivo = !this.modalActivo
    setTimeout(() => {
      document.getElementById('modal-focus').setAttribute('tabindex', '0')
      document.getElementById('modal-focus').focus()
    }, 500);
    if (this.modalActivo) {
      this.renderer.addClass(this.blur.nativeElement, 'active')
      this.renderer.addClass(this.popup.nativeElement, 'active')
    }
    else {
      this.renderer.removeClass(this.blur.nativeElement, 'active')
      this.renderer.removeClass(this.popup.nativeElement, 'active')
    }
  }
}
